'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var React = require('react');
var index = require('../../../../types/index.js');
var context = require('../context.js');
var getIconComponent = require('../../../../utils/getIconComponent.js');
var index$1 = require('../../../../core/Link/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const StyledIcon = styled__default["default"].div(
  ({ commonStyle, iconStyle }) => `
  display: flex;
  ${coreRenderer.getStyle(iconStyle)}
  ${coreRenderer.getStyle(commonStyle)}
`
);
const ListItemIconV2 = React__default["default"].forwardRef((props, ref) => {
  const { commonStyle, event, icon, position } = props;
  const { iconConfig, iconStyle } = React.useContext(context.ListItemContext);
  const GlobalIcon = getIconComponent.getIconCompoment(iconConfig == null ? void 0 : iconConfig.icon);
  const IconComponent = getIconComponent.getIconCompoment(icon);
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      position === index.Position.behind && /* @__PURE__ */ jsxRuntime.jsx("div", {
        style: { width: iconConfig.spacing }
      }),
      /* @__PURE__ */ jsxRuntime.jsx(StyledIcon, {
        ref,
        commonStyle,
        iconStyle,
        children: /* @__PURE__ */ jsxRuntime.jsx(index$1.Link, __spreadProps(__spreadValues({}, event), {
          children: IconComponent || GlobalIcon
        }))
      }),
      position === index.Position.front && /* @__PURE__ */ jsxRuntime.jsx("div", {
        style: { width: iconConfig.spacing }
      })
    ]
  });
});
ListItemIconV2.displayName = "ListItemIconV2";

exports.ListItemIconV2 = ListItemIconV2;
